export const formatPhoneNumber = (unformatted: string): string => {
    let stripped = unformatted.replaceAll(' ', '');
    if (stripped !== '' && `${parseInt(stripped)}`.length !== stripped.length) {
        return '';
    }
    let formattedPhoneNumber: string = '';
    if (stripped.length <= 2) {
        formattedPhoneNumber = stripped;
    } else if (stripped.length <= 4) {
        formattedPhoneNumber = stripped.slice(0, 2) + ' ' + stripped.slice(2, 4);
    } else if (stripped.length <= 6) {
        formattedPhoneNumber = stripped.slice(0, 2) + ' ' + stripped.slice(2, 4) + ' ' + stripped.slice(4, 6);
    } else {
        formattedPhoneNumber =
            stripped.slice(0, 2) + ' ' + stripped.slice(2, 4) + ' ' + stripped.slice(4, 6) + ' ' + stripped.slice(6, 8);
    }
    return formattedPhoneNumber;
};
